module.exports = __webpack_public_path__ + "img/q6.f9024c5e.png";